import { I18n } from '@affine/i18n';

import type { SignedPdfVersionInfo } from '../../../desktop/dialogs/setting/workspace-setting/signatures/use-workspace-pdf-signatures';

export function getSignedPdfBadgeLabel() {
  return I18n.t('com.streamlain.pdf.signature.signedBadge.label');
}

export function getSignedPdfBadgeShortLabel() {
  return I18n.t('com.streamlain.pdf.signature.signedBadge.short');
}

export function getSignedPdfBadgeTitle(version: SignedPdfVersionInfo) {
  return I18n.t('com.streamlain.pdf.signature.signedBadge.title', {
    status: version.validationState,
  });
}

export function getPlaceSignedPdfCopyLabel() {
  return I18n.t('com.streamlain.pdf.signature.signedCopy.placeOnCanvas');
}

export function getPlacingSignedPdfCopyLabel() {
  return I18n.t('com.streamlain.pdf.signature.signedCopy.placingOnCanvas');
}

export function getSignedPdfCopyPlacedLabel() {
  return I18n.t('com.streamlain.pdf.signature.signedCopy.placedOnCanvas');
}
